<template>
  <div class="container presentation-container page-content">
    <header style="background-color: #05689a;height: auto;width: 100%;padding: 25px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-logo-white.png"  height="68" width="230" alt="Logo">
          <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/realshield-logo-white.png"  height="68" width="230" alt="Logo">
          <img v-else src="../../../public/assets/images/orep-white-logo.png"  height="68" width="230" alt="Logo">
        </div>
      </div>
    </header>
    <div style="padding-left: 50px;padding-right: 50px;padding-top: 20px;">

      <div class="row">
        <div class="col-md-8">
          <p class="comic-font-bold" style="font-size: 30px; color: #05689a">
            <strong>Real Estate Agent/Broker Errors & Omissions</strong>
          </p>
          <p class="comic-font-bold" style="font-size: 30px;">
            PREMIUM PROPOSAL
          </p>
        </div>
        <div class="col-md-auto text-center">
          <img v-if="getApplicantType === 'Mercer'" src="../../../public/assets/images/mercer-call.png" class="w-100" alt="18 years">
          <img v-else-if="getApplicantType === 'Realshield'" src="../../../public/assets/images/call-1.png" class="w-100" alt="18 years">
          <img v-else src="../../../public/assets/images/call-1.png" class="w-100" alt="18 years">
        </div>
      </div>
      <hr class="new1" />

      <div class="row justify-content-center" style="margin-top: 30px">
        <div class="col-md-10 text-left">
          <div class="row">
            <div class="col-md-auto text-center">
              <p class="comic-font-bold" style="font-size: 20px;">
                PREMIUM PREPARED FOR: {{ rxApplication.applicantFirmName }}
              </p>
            </div>
          </div>

          <hr class="new1">
        </div>
      </div>
      <div class="row justify-content-center" style="margin-top: 20px">
        <div class="col-md-10 text-left">
          <table class="w-100">
            <tbody>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>LIMITS OF COVERAGE:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder=coverage()  class="w-100" disabled>
              </td>
            </tr>
            <tr>
              <td style="margin-bottom: 3rem !important;">
                <strong>Deductible:</strong>
              </td>
              <td>
                <input :placeholder="deductible()" class="w-100" disabled>
              </td>
            </tr>

            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>PREMIUM:</strong>
                </p>
              </td>
              <td>
                <input type="text" :placeholder="'$'+(state.totalPremium).toFixed(2)"  class="w-100" disabled>
              </td>
            </tr>

            <tr>
              <td>
                <strong>OREP Member Fee:</strong>
              </td>
              <td>
                <input type="text" :placeholder="'$'+ orepfee().toFixed(2)"  class="w-100" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <strong>State Tax:</strong>
              </td>
              <td>
                <input :placeholder="'$'+(state.totalPremiumStateTax).toFixed(2)" class="w-100" disabled>
              </td>
            </tr>
            <tr>
              <td>
                <p class="comic-font-bold" style="color: #05689a">
                  <strong>TOTAL:</strong>
                </p>
              </td>
              <td>
                <input :placeholder="'$'+ total().toFixed(2)" class="w-100" disabled>
              </td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>

      <div class="row justify-content-center" style="margin-top: 30px">
        <div class="col-md-10 text-left">
          <div class="row">
            <div class="col-md-auto text-left">
              <p>
                <strong>
                  <i>Please Note:</i>
                </strong>
                Your Insurance Policy is not in effect/bound until Payment or Down-Payment is received. <strong style="text-decoration: underline">To expedite coverage and avoid delays, please use one of these two links to make payment now.</strong>
              </p>
            </div>
            <div class="d-flex my-5" v-if="state.premium !== 0">
              <button type="submit" :disabled="!state.pageSixIsValid" :class="{submitDisabled: !state.pageSixIsValid}"
                      class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                      @click="navigateToNext('rx-application-payment')">PAY IN FULL NOW</button>
              <router-link
                :to="{name: 'rx-application-request-financing', params: {id: rxApplication.id}}"
                class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                target="_blank"
                v-if="rxApplication.customer.state === 'KY'"
              >
                REQUEST FINANCING
              </router-link>

<!--              <a v-else-if="getApplicantType === 'Mercer'"-->
<!--                 v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ rxApplication.applicantFirmName+'&ia_name='+rxApplication.contact+'&address='+encodeURIComponent(rxApplication.customer.address)+'&city='+rxApplication.customer.city+'&state_code='+rxApplication.customer.state+'&zip='+rxApplication.customer.zipCode+'&phone='+rxApplication.customer.phone+'&email='+rxApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+total_without_fee().toFixed(2)"-->
<!--                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                 target="_blank">REQUEST FINANCING</a>-->
<!--              <a v-else-if="getApplicantType === 'Realshield'"-->
<!--                 v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ rxApplication.applicantFirmName+'&ia_name='+rxApplication.contact+'&address='+encodeURIComponent(rxApplication.customer.address)+'&city='+rxApplication.customer.city+'&state_code='+rxApplication.customer.state+'&zip='+rxApplication.customer.zipCode+'&phone='+rxApplication.customer.phone+'&email='+rxApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+total_without_fee().toFixed(2)"-->
<!--                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                 target="_blank">REQUEST FINANCING</a>-->
<!--              <a v-else-->
<!--                 v-bind:href="'https://orep.org/financehudson50/index.php?name='+ rxApplication.applicantFirmName+'&ia_name='+rxApplication.contact+'&address='+encodeURIComponent(rxApplication.customer.address)+'&city='+rxApplication.customer.city+'&state_code='+rxApplication.customer.state+'&zip='+rxApplication.customer.zipCode+'&phone='+rxApplication.customer.phone+'&email='+rxApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+total_without_fee().toFixed(2)"-->
<!--                 class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--                 target="_blank">REQUEST FINANCING</a>-->
              <a
                  v-bind:href="this.state.requestFinancingPaymentLink"
                  class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                  target="_blank">REQUEST FINANCING</a>
            </div>
            <div v-if="getApplicantType === 'OREP'" class="col-md-auto text-left small">
              <p class="input-info">
                <i class="fas fa-exclamation-triangle not-eligible"></i><span class="not-eligible-text">
                  If you are new to OREP, please email a copy of your Expiring Declarations Page to
                  <strong><a href="mailto:info@orep.org" target="_top">info@orep.org</a></strong>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr class="new1" />
      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          PROGRAM HIGHLIGHTS
        </p>
      </div>

      <div class="row justify-content-center" style="margin-top: 30px">
        <div class="col-md-10 text-left">
        <ul>
          <li style="padding-bottom:1em">Broad Coverage for Real Estate Agents</li>
          <li style="padding-bottom:1em">"A" Rated, Admitted Carrier (AM Best Rating)</li>
          <li style="padding-bottom:1em">Lockbox and Open House Coverage to Full Policy Limits</li>
          <li style="padding-bottom:1em">Up to $500,000 Mold/Fungi Coverage</li>
          <li style="padding-bottom:1em">Up to $500,000 Discrimination Coverage</li>
          <li style="padding-bottom:1em">$100,000 Bodily Injury/Property Damage Coverage</li>
          <li style="padding-bottom:1em">$25,000 Disciplinary Proceedings Coverage </li>
          <li style="padding-bottom:1em">$25,000 Subpoena Assistance</li>
          <li style="padding-bottom:1em">$25,000 Security Incident Coverage</li>
          <li style="padding-bottom:1em">FREE extended reporting period in case of disability/death</li>
          <li style="padding-bottom:1em">FREE extended reporting period upon retirement (for qualified applicants)</li>
          <li style="padding-bottom:1em">OREP Serving Real Estate Professionals’ E&O Insurance Needs over 20 Years </li>
        </ul>
        </div>
      </div>

      <div class="col text-center" style="margin-top: 50px;background-color:  #05689a">
        <p class="comic-font-bold" style="font-size: 25px; color: white">
          WHY OREP?
        </p>
      </div>
      <div class="row justify-content-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div class="col-md-10 text-left">
          <ul>
            <li style="padding-bottom:1em">Comprehensive Coverage, Competitive Rates</li>
            <li style="padding-bottom:1em">20% off your Continuing Education (most states)</li>
            <li style="padding-bottom:1em">Discounts on Home Warranties</li>
            <li style="padding-bottom:1em">Free Risk Management and Claims Support </li>
            <li style="padding-bottom:1em">Guaranteed Delivery of Working RE Magazine </li>
            <li style="padding-bottom:1em"><a href="https://orep.org/real-estate-agent-benefits/" target="_blank">Click here</a> for all Agent/Broker Benefits</li>

          </ul>
        </div>
      </div>
      <div class="row justify-content-center" style="margin-top: 30px;margin-bottom: 50px;">
        <div class="col-md-10 text-left">
          <div class="d-flex my-5" v-if="state.premium !== 0">
            <button type="submit" :disabled="!state.pageSixIsValid" :class="{submitDisabled: !state.pageSixIsValid}"
                    class="text-uppercase text-center comic-font-bold" style="margin-right: 65px; border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
                    @click="navigateToNext('rx-application-payment')">PAY IN FULL NOW</button>
            <router-link
              :to="{name: 'rx-application-request-financing', params: {id: rxApplication.id}}"
              class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
              target="_blank"
              v-if="rxApplication.customer.state === 'KY'"
            >
              REQUEST FINANCING
            </router-link>

<!--            <a v-else-if="getApplicantType === 'Mercer'"-->
<!--               v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ rxApplication.applicantFirmName+'&ia_name='+rxApplication.contact+'&address='+encodeURIComponent(rxApplication.customer.address)+'&city='+rxApplication.customer.city+'&state_code='+rxApplication.customer.state+'&zip='+rxApplication.customer.zipCode+'&phone='+rxApplication.customer.phone+'&email='+rxApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+total_without_fee().toFixed(2)"-->
<!--               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--               target="_blank">REQUEST FINANCING</a>-->
<!--            <a v-else-if="getApplicantType === 'Realshield'"-->
<!--               v-bind:href="'https://orep.org/financehudson50-mercer/index.php?name='+ rxApplication.applicantFirmName+'&ia_name='+rxApplication.contact+'&address='+encodeURIComponent(rxApplication.customer.address)+'&city='+rxApplication.customer.city+'&state_code='+rxApplication.customer.state+'&zip='+rxApplication.customer.zipCode+'&phone='+rxApplication.customer.phone+'&email='+rxApplication.customer.email+'&date='+getEffectiveDate()+'&premium='+total_without_fee().toFixed(2)"-->
<!--               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"-->
<!--               target="_blank">REQUEST FINANCING</a>-->
            <a
               v-bind:href="this.state.requestFinancingPaymentLink"
               class="text-uppercase text-center comic-font-bold" style="border-radius: 20px;padding: 20px;background-color: #FB7F03;  border: none; color:white;text-align: center;text-decoration: none;display: inline-block;font-size: 25px;margin: 4px 2px;cursor: pointer;"
               target="_blank">REQUEST FINANCING</a>
          </div>
        </div>
      </div>
    </div>


    <footer v-if="getApplicantType === 'Mercer'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/mercer-logo-white.png" class="w-100" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            AMBA
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            PO Box 4050 NW 114th Street, Bldg 19
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Urbandale, IA  50322
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            1-866-795-9613
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            amba.service@amba.info
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits Advisors, LLC. In CA d/b/a
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            Association Member Benefits & Insurance Agency
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            CA Insurance License #0I96562
          </p>
        </div>
      </div>

    </footer>

    <footer v-if="getApplicantType === 'Realshield'" style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/realshield-logo-white.png" class="w-100" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC || CA License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            info@OREP.org
          </p>
        </div>
      </div>

    </footer>

    <footer v-else style="background-color: #05689a;height: auto;width: 100%;padding: 40px;color: white">
      <div class="row">
        <div class="col-sm-4">
          <img src="../../../public/assets/images/white-logo.png" class="w-100" alt="Logo">
        </div>
        <div class="col-sm-8">
          <p class="comic-font-bold" style="font-size: 18px;">
            OREP Insurance Services, LLC || CA License #0K99465
          </p>
          <br />
          <p class="comic-font-bold" style="font-size: 18px;">
            6353 El Cajon Blvd, Suite 124-605
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            San Diego, CA 92115
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            (888) 347-5273
          </p>
          <p class="comic-font-bold" style="font-size: 18px;">
            info@OREP.org
          </p>
        </div>
      </div>

    </footer>
  </div>

</template>

<script>
import $ from "jquery";
import moment from "moment";
export default {
  name: "rx-application-representation",
  computed: {

    rxApplication() {
      return this.$store.state.rxApplication.rxApplication;
    },
    state() {
      return this.$store.state.rxApplication;
    },
    errorMsg() {
      return this.$store.state.rxApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/rx-application-amba/' || this.rxApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/rx-application-realshield/' || this.rxApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },
  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    getEffectiveDate() {
      return moment.utc(this.state.rxApplication.effectiveDate).format('MM/DD/YYYY');
    },
    total() {
      return  this.state.totalPremium + this.state.totalPremiumStateTax + this.state.orepFee;
    },
    total_without_fee() {
      return  this.state.totalPremium + this.state.totalPremiumStateTax;
    },

    deductible(){
      switch (this.rxApplication.deductible) {
        case '5000':
          return '$5,000';
        case '2500':
          return '$2,500';
        default:
          return '$1,000';
      }
    },

    coverage() {
      switch (this.rxApplication.limitOfCoverage) {
        case '0.1M/0.3M':
          return '$100,000 / $300,000';
        case '0.25M/0.25M':
          return '$250,000 / $250,000';
        case '0.5M/0.5M':
          return '$500,000 / $500,000';
        case '0.5M/1M':
          return '$500,000 / $1,000,000';
        default:
          return '$1,000,000 / $1,000,000';
      }
    },
    orepfee() {
      // if (this.rxApplication.customer.state === 'CO' || this.rxApplication.customer.state === 'FL') {
      if (this.rxApplication.customer.state === 'CO') {
        return 60;
      }
      else {
        if (this.state.premium !== 0) {
          return 60;
        }
        else {
          return 60;
        }
      }
    },
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.presentation-container').offset().top
    }, 500);
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
.container {
  background-color: white !important;
  padding-right: 0px;
  padding-left: 0px;
}
.img-call {
  height: 170px;
  max-height: 170px;
}
p {
  margin: 5px 0;
}
.strong {
  font-weight: bold !important;
}
li{
  margin: 12px 0;
}
table td {
  padding: 0 5px 15px !important;
}

table > tbody > tr > td:last-child {
  width: 65%
}


::placeholder {
  color: black;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}
.table-bordered td {
  vertical-align: top;
  border-right: 2px solid #dee2e6;
  border-left-width: 0;
  border-bottom-width: 0;
  border-top-width: 0;
}
* {
  box-sizing: border-box;
}

/* Create three unequal columns that floats next to each other */
.column {
  float: center;
  padding: 10px;
  height: 300px; /* Should be removed. Only for demonstration */
}

.left {
  width: 25%;
}
.right {
  width: 5%;
}

.middle {
  width: 63%;
}

.comic-font{
  font-family: 'Open Sans';
}
.comic-font-bold{
  font-family: 'Open Sans';
  font-weight: bold;
}
hr.new1 {
  border-top: 1px solid grey;
}
.no-gutter > [class*='col-'] {
  padding-right:0;
  padding-left:0;
}
</style>
